/**
 * @prettier
 */
export const MobileAppEvents = {
    CREATE_AND_DOWNLOAD_DELIVERY_ITEM_LABELS: 'CREATE_AND_DOWNLOAD_DELIVERY_ITEM_LABELS',
    PRINT_PRINTER_INSTRUCTIONS: 'PRINT_PRINTER_INSTRUCTIONS',
    SET_SIGN_IN_CREDENTIALS: 'SET_SIGN_IN_CREDENTIALS',
    SET_DEVICE_ID: 'SET_DEVICE_ID',
    SET_PIDE_DIRECTO_ADMIN_VERSION: 'SET_PIDE_DIRECTO_ADMIN_VERSION',
    SET_PIN_CODE_USER: 'SET_PIN_CODE_USER',
    SET_RESTAURANT_HAS_BLUETOOTH_PRINTERS: 'SET_RESTAURANT_HAS_BLUETOOTH_PRINTERS',
    SET_RESTAURANT_IDS: 'SET_RESTAURANT_IDS',
    SET_DEVELOPER_MODE: 'SET_DEVELOPER_MODE',
    SET_SHOULD_PLAY_ALERT_SOUND: 'SET_SHOULD_PLAY_ALERT_SOUND',
    SOUND_MUTED: 'SOUND_MUTED',
    SIGNED_IN: 'SIGNED_IN',
    SIGNED_OUT: 'SIGNED_OUT',
} as const;

export type MobileAppEvent = (typeof MobileAppEvents)[keyof typeof MobileAppEvents];
